import React, { useState, cloneElement, useCallback } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';

import withUserCheck from '../../../utils/withUserCheck';
import { translate } from '../../../i18n/I18nProvider';
import { actions as showHistoryReduxActions } from '../../../modals/showHistory/reducers';
import { actions as showDatalimitReduxActions } from '../../../modals/showDatalimit/reducers';
import { actions as datalimitLogsReduxActions } from '../../../modals/datalimitLogs/reducers';
import can from '../../../utils/can';
import createSubject from '../../../utils/createSubject';
import DeleteDatalimitConfimation from './DeleteDatalimitConfimation';
import ConfirmDialog from '../../../partials/confirmationDialog/ConfirmDialog';
import { doesArrayHasLength } from '../../../utils/isDefined';
import { removeDatalimit } from '../actions/deleteDatalimit';

const MoreActionsMenu = ({
  children,
  dataLimit = {},
  openShowHistory,
  openShowDatalimit,
  openDatalimitLogs,
  setRefresh,
  removeDatalimit
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onHistoryClick = useCallback(
    () => {
      openShowHistory({
        id: dataLimit.id,
        itemType: 'DataLimit',
        titleText: dataLimit.name,
        historyObject: dataLimit,
        itemTypeKey: 'DATA_LIMITS.DATALIMIT'
      });
      handleClose();
    },
    // eslint-disable-next-line
    [dataLimit.id]
  );

  const onShowClick = useCallback(
    () => {
      openShowDatalimit(dataLimit.id, dataLimit.name);
      handleClose();
    },
    // eslint-disable-next-line
    [dataLimit.id, dataLimit.name]
  );

  const onLogsClick = useCallback(
    () => {
      openDatalimitLogs(dataLimit?.id);
      handleClose();
    },
    // eslint-disable-next-line
    [dataLimit.id]
  );

  const onDeleteClick = useCallback(
    () => {
      removeDatalimit(dataLimit?.id, setRefresh);
      handleClose();
    },
    // eslint-disable-next-line
    [dataLimit.id]
  );

  return (
    <div>
      {cloneElement(children, { onClick: handleClick })}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem onClick={onHistoryClick}>
          {translate('TOOLTIP.SHOW_HISTORY')}
        </MenuItem>
        <MenuItem onClick={onShowClick}>
          {translate('DATA_LIMITS.SHOW_DATALIMIT')}
        </MenuItem>
        <MenuItem onClick={onLogsClick}>
          {translate('DATA_LIMITS.SHOW_DATALIMIT_LOGS')}
        </MenuItem>
        {can(
          'delete',
          createSubject('DataLimit', {
            client_id: Number(dataLimit.client?.id)
          })
        ) && (
          <div>
            <ConfirmDialog
              closeMenu={handleClose}
              onConfirmClick={onDeleteClick}
              dialogContentComponent={<DeleteDatalimitConfimation />}
              dialogTitleIntlId={'TOOLTIP.DELETE_DATALIMIT'}
            >
              <MenuItem disabled={doesArrayHasLength(dataLimit?.cell_numbers)}>
                {translate('TOOLTIP.DELETE_DATALIMIT')}
              </MenuItem>
            </ConfirmDialog>
          </div>
        )}
      </Menu>
    </div>
  );
};

const mapDispatchToProps = {
  openShowHistory: showHistoryReduxActions.openShowHistory,
  openShowDatalimit: showDatalimitReduxActions.openShowDatalimit,
  openDatalimitLogs: datalimitLogsReduxActions.openDatalimitLogs,
  removeDatalimit
};

export default flowRight(
  withUserCheck,
  connect(null, mapDispatchToProps)
)(MoreActionsMenu);
